<div class="flex-column">
    <div class="flex-row align-space-between-center pxs-5">
        <span class="headline-1 mbs-5 text-primary-darker-title">
            {{ ('modules.admissions.dashboard.template-title' | exp:'':'Dashboard') }}
        </span>
        <div class="flex-row align-space-between-center flex-30">
            <app-select-searching-input style="height: 50px !important;" class="flex-45" [name]="this.OPERATOR"
                [nameSearching]="this.OPERATOR_SEARCHING" [form]="this.filterForm" [placeholder]="('modules.admissions.dashboard.placeholders.select-operator' | exp:'':'Operador')"
                [elements]="(this.operators)" [defaultValue]="this.operator" [calculateId]="this.calculateIdOperator"
                [calculateName]="this.calculateNameOperator" [placeholderNoValue]="('modules.admissions.dashboard.placeholders.no-value' | exp:'':'Sin resultados')"
                [placeholderSearching]="('modules.admissions.dashboard.placeholders.searching-operator' | exp:'':'Buscar...')" [noOptionText]="('modules.admissions.dashboard.placeholders.no-option' | exp:'':'-- Todos --')">
            </app-select-searching-input>
            <button id="btnOpenCreateAdmission" mat-flat-button [color]="'primary'"
                class="big-button big-button-add-admission" (click)="this.openCreateAdmission()"
                [disabled]="(!this.authenticationService.isFrontDesk() && !this.authenticationService.isAdmin())">
                <span class="flex-100" style="font-size: small;">{{ ('modules.admissions.dashboard.create-admission' | exp:'':'Crear admisión')  }}</span>
            </button>
        </div>
    </div>
    <div class="flex-row align-space-between-none gap-0-7em">
        <!-- Cards -->
        <div class="flex-row align-space-between-none flex-98 pxs-5" style="place-content: stretch space-between;">
            <!-- Indicators - LEFT  -->
            <app-theme-card themeScope="admissions" [fullWidth]="false" cardClass="shadow-lg mat-elevation-z5 theme-sized-card">
                <div class="grid-container" style="height: 100%;">
                    <div class="c1 border-bottom text-secondary align-start-center">
                        <div class="p-4" style="margin: 0.5rem;">
                            <span>{{ ('modules.admissions.dashboard.admissions' | exp:'':'Admisiones')  }}</span>
                        </div>
                    </div>
                    <div class="c2 border-bottom border-right clickable-indicator" (click)="this.stateSelected = 0">
                        <div class="flex-column align-center-center ">
                            <span class="mat-display-2 label-1 number-font big-number" style="margin: 0;">{{ requisitionsNews }}</span>
                            <span class="text-chrome">{{ ('modules.admissions.dashboard.requisitions' | exp:'':'Solicitudes')  }}</span>
                        </div>
                    </div>
                    <div class="c3" *tenantFeature="'admissionsDashboard.updatesIndicator'">
                        <div class="flex-row align-center-center">
                            <span class="label-1 number-font small-number mb-0">{{ requisitionsUpdate }}</span>
                            <span class="text-chrome ml-2" style="font-size: 12px;">{{ ('modules.admissions.dashboard.requisitions-updates' | exp:'':'Actualizaciones')  }}</span>
                        </div>
                    </div>
                    <!-- Label & number Nº2 -->
                    <div class="c4">
                        <div (click)="stateSelected = 2" class="clickable-indicator">
                            <span class="number-font small-number label-1 number-indicator-2">{{ requisitionsWithoutWarning }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2" >{{ ('modules.admissions.dashboard.requisitions-without-warning' | exp:'':'Sin aviso al f')  }}</span>
                        </div>
                        <div (click)="stateSelected = 3" class="clickable-indicator">
                            <span class="number-font small-number label-2 number-indicator-2">{{ requisitionsWaitingForInfo }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.requisitions-waiting-info' | exp:'':'Esperando info')  }}</span>
                        </div>
                        <div (click)="stateSelected = 4" class="clickable-indicator">
                            <span class="number-font small-number label-3 number-indicator-2">{{ requisitionsSearchingResources }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.requisitions-searching-resources' | exp:'':'Buscando rec')  }}</span>
                        </div>
                        <div (click)="stateSelected = 5" class="clickable-indicator">
                            <span class="number-font small-number label-4 number-indicator-2">{{ requisitionsConfirmed }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.requisitions-confirmed' | exp:'':'Confirmado')  }}</span>
                        </div>
                        <div *tenantFeature="'admissionsDashboard.budgetedState'" (click)="stateSelected = 6" class="clickable-indicator">
                            <span class="number-font small-number label-5 number-indicator-2">{{ requisitionsBudgeted }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.requisitions-budgeted' | exp:'':'Presupuestado')  }}</span>
                        </div>
                    </div>
                </div>
            </app-theme-card>
            <!-- Indicators - CENTER  -->
            <app-theme-card *tenantFeature="'admissionsDashboard.complexityIndicators'" themeScope="admissions" [fullWidth]="false" cardClass="shadow-lg mat-elevation-z5 theme-sized-card">
                <div class="grid-container" style="height: 100%;">
                    <div class="c1 flex border-bottom text-secondary align-start-center">
                        <div class="p-4" style="margin: 0.5rem;">
                            <span>{{ ('modules.admissions.dashboard.requisitions' | exp:'':'Solicitudes')  }}</span>
                        </div>
                    </div>
                    <div class="c22 border-right">
                        <div class="flex-column align-center-center mbs-5">
                            <span class="mat-display-2 label-1 number-font big-number" style="margin: 0;">{{ requisitionsWithoutWarning }}</span>
                            <span class="text-chrome">{{ ('modules.admissions.dashboard.requisitions-without-warning' | exp:'':'Sin aviso al f')  }}</span>
                        </div>
                    </div>
                    <div class="c33 border-right">
                        <div class="flex-row align-start-center">
                        </div>
                    </div>
                    <!-- Label & number Nº2 -->
                    <div class="c44">
                        <div>
                            <span class="number-font small-number label-1 number-indicator-2">{{ requisitionsComplexityA }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.complexity.a' | exp:'':'Complejidad A')  }}</span>
                        </div>
                        <div>
                            <span class="number-font small-number label-1 number-indicator-2">{{ requisitionsComplexityB }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.complexity.b' | exp:'':'Complejidad B')  }}</span>
                        </div>
                        <div>
                            <span class="number-font small-number label-1 number-indicator-2">{{ requisitionsComplexityC }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.complexity.c' | exp:'':'Complejidad C')  }}</span>
                        </div>
                    </div>
                </div>
            </app-theme-card>
            <!-- Indicators - RIGHT  -->
            <app-theme-card *tenantFeature="'admissionsDashboard.authorizedIndicators'" themeScope="admissions" [fullWidth]="false" cardClass="shadow-lg mat-elevation-z5 theme-sized-card">
                <div class="grid-container" style="height: 100%;">
                    <div class="c1 border-bottom">
                        <div class="p-4 flex-row align-end-center" style="padding: 0.5rem;">
                            <form [formGroup]="filterFormCardRequisitionsAuthorized" class="flex-row align-end-center">
                                <!-- TODO: i18n frecuencyPeriod filter option labels — SX-3298 -->
                                <app-select-input style="height:40px !important;" [name]="this.FRECUENCY_AUTHORIZED"
                                    [form]="this.filterFormCardRequisitionsAuthorized"
                                    [elements]="this.frecuencyPeriod" [defaultValue]="frecuencyPeriod_default"
                                    (selected)="frecuencySelected($event)">
                                </app-select-input>
                            </form>
                        </div>
                    </div>
                    <div class="c222 border-right">
                        <div class="flex-column align-center-center mbs-2">
                            <span class="mat-display-2 label-2 number-font big-number" style="margin: 0;">{{ requisitionsAuthorized }}</span>
                            <span class="label-2">{{ ('modules.admissions.dashboard.requisitions-authorized' | exp:'':'Autorizadas')  }}</span>
                        </div>
                    </div>
                    <div class="c333 border-right">
                        <div class="flex-row align-center-center">
                            <span class="text-chrome number-font small-number number-indicator-2">{{ totals }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.totals' | exp:'':'Totales')  }}</span>
                        </div>
                    </div>
                    <!-- Label & number Nº2 -->
                    <div class="c444">
                        <div>
                            <span class="number-font small-number label-2 number-indicator-2">{{ requisitionsAuthorizedComplexityA }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.complexity.a' | exp:'':'Complejidad A')  }}</span>
                        </div>
                        <div>
                            <span class="number-font small-number label-2 number-indicator-2">{{ requisitionsAuthorizedComplexityB }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.complexity.b' | exp:'':'Complejidad B')  }}</span>
                        </div>
                        <div>
                            <span class="number-font small-number label-2 number-indicator-2">{{ requisitionsAuthorizedComplexityC }}</span>
                            <span class="text-primary-darker subtitle-5 label-indicator-2">{{ ('modules.admissions.dashboard.complexity.c' | exp:'':'Complejidad C')  }}</span>
                        </div>
                    </div>
                </div>
            </app-theme-card>
        </div>
    </div>
    <div class="mb-1"></div>
    <!-- Admissions table list -->
    <div class="pls-5">
        <app-admissions-list [requisitions]="requisitions" [loading]="loading" [columns]="columnsToShow"
            [operator]="operator" [indicatorSelected]="stateSelected"></app-admissions-list>
    </div>
</div>
